"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  .ant-modal-wrap {\n    pointer-events: none;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  img {\n    max-width: 100%;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  cursor: pointer;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  &:hover ", " {\n    opacity: 1;\n    pointer-events: all;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  background: ", ";\n  border-radius: ", ";\n  pointer-events: none;\n  transition: opacity 0.25s linear;\n  padding: ", ";\n  opacity: 0;\n  cursor: pointer;\n  z-index: 4;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoutContent = exports.PopoutModalButton = exports.PopoutModal = exports.ViewMode = void 0;

var antd_1 = require("antd");

var iconoir_react_1 = require("iconoir-react");

var react_1 = __importDefault(require("react"));

var react_new_window_1 = __importDefault(require("react-new-window"));

var styled_components_1 = require("styled-components");

var AntIconWrapper_1 = require("./AntIconWrapper");

var AntStyled_1 = require("./AntStyled");

var Reset_1 = require("./Reset");

var ResizeableModal_1 = require("./ResizeableModal");

var styledTypes_1 = require("./styledTypes");

var ViewMode;

(function (ViewMode) {
  ViewMode["InBrowser"] = "browser";
  ViewMode["Window"] = "window";
})(ViewMode = exports.ViewMode || (exports.ViewMode = {}));

function PopoutModal(_a) {
  var title = _a.title,
      visible = _a.visible,
      onCancel = _a.onCancel,
      children = _a.children,
      _a$defaultViewMode = _a.defaultViewMode,
      defaultViewMode = _a$defaultViewMode === void 0 ? ViewMode.InBrowser : _a$defaultViewMode,
      _a$defaultWidth = _a.defaultWidth,
      defaultWidth = _a$defaultWidth === void 0 ? 500 : _a$defaultWidth,
      _a$defaultHeight = _a.defaultHeight,
      defaultHeight = _a$defaultHeight === void 0 ? 300 : _a$defaultHeight,
      modalProps = __rest(_a, ["title", "visible", "onCancel", "children", "defaultViewMode", "defaultWidth", "defaultHeight"]);

  var _react_1$default$useS = react_1.default.useState(visible ? defaultViewMode : null),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      viewMode = _react_1$default$useS2[0],
      setViewMode = _react_1$default$useS2[1];

  react_1.default.useEffect(function () {
    setViewMode(visible ? defaultViewMode : null);
  }, [visible]);
  var lastWidth = react_1.default.useRef(defaultWidth);
  var lastHeight = react_1.default.useRef(defaultHeight);
  var modalRef = react_1.default.useRef(null);

  if (viewMode === ViewMode.Window) {
    return react_1.default.createElement(react_new_window_1.default, {
      title: title || 'Viewing Content',
      features: {
        popup: true,
        width: lastWidth.current,
        height: lastHeight.current
      },
      onUnload: function onUnload() {
        if (onCancel) {
          onCancel({});
        }
      },
      onBlock: function onBlock() {
        setViewMode(ViewMode.InBrowser);
        antd_1.message.error('You need to disable your popup blocker in order to open this content in a new window.');
      }
    }, react_1.default.createElement(WindowContentContainer, null, children));
  } else {
    return react_1.default.createElement(react_1.default.Fragment, null, visible ? react_1.default.createElement(PopoutGlobalStyles, null) : null, react_1.default.createElement(ResizeableModal_1.ResizeableModal, Object.assign({}, modalProps, {
      title: title || undefined,
      visible: !!viewMode,
      onCancel: onCancel,
      modalRef: modalRef,
      mask: false,
      maskClosable: false,
      topRightActions: react_1.default.createElement(react_1.default.Fragment, null, modalProps.topRightActions, react_1.default.createElement(AntStyled_1.Tooltip, {
        title: 'Open in New Window'
      }, react_1.default.createElement(PopoutIconContainer, {
        onClick: function onClick(e) {
          e.stopPropagation();
          var modal = e.target.closest('.feature-modal');

          if (modal) {
            lastWidth.current = modal.clientWidth;
            lastHeight.current = modal.clientHeight;
          }

          setViewMode(ViewMode.Window);
        }
      }, react_1.default.createElement(AntIconWrapper_1.AntIconWrapper, {
        children: react_1.default.createElement(iconoir_react_1.MultiWindow, null)
      }))))
    }), children));
  }
}

exports.PopoutModal = PopoutModal;

function PopoutModalButton(_a) {
  var buttonChildren = _a.buttonChildren,
      rest = __rest(_a, ["buttonChildren"]);

  var _react_1$default$useS3 = react_1.default.useState(false),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      visible = _react_1$default$useS4[0],
      setVisible = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState(undefined),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      defaultViewMode = _react_1$default$useS6[0],
      setDefaultViewMode = _react_1$default$useS6[1];

  var button = buttonChildren || react_1.default.createElement(antd_1.Button, {
    icon: react_1.default.createElement(AntIconWrapper_1.AntIconWrapper, {
      children: react_1.default.createElement(iconoir_react_1.MultiWindow, null)
    })
  });
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(PopoutModal, Object.assign({}, rest, {
    visible: visible,
    onCancel: function onCancel() {
      return setVisible(false);
    },
    defaultViewMode: defaultViewMode
  })), react_1.default.cloneElement(button, {
    onClick: function onClick(e) {
      setDefaultViewMode(e.ctrlKey || e.metaKey ? ViewMode.Window : ViewMode.InBrowser);
      setVisible(true);
    }
  }));
}

exports.PopoutModalButton = PopoutModalButton;

function PopoutContent(_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  return react_1.default.createElement(ContentContainer, null, react_1.default.createElement(PopoutModalButton, Object.assign({}, rest, {
    buttonChildren: react_1.default.createElement(AntStyled_1.Tooltip, {
      title: 'Open in Pop-out Window',
      placement: 'bottomRight'
    }, react_1.default.createElement(PopContentButton, null, react_1.default.createElement(AntIconWrapper_1.AntIconWrapper, {
      children: react_1.default.createElement(iconoir_react_1.MultiWindow, null)
    })))
  }), children), children);
}

exports.PopoutContent = PopoutContent;
var PopContentButton = (0, styledTypes_1.styled)(Reset_1.Reset.Button)(_templateObject(), function (props) {
  return props.theme['@gray-0'];
}, function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@size-xs'];
});
var ContentContainer = styledTypes_1.styled.div(_templateObject2(), PopContentButton);
var PopoutIconContainer = (0, styledTypes_1.styled)(Reset_1.Reset.Button)(_templateObject3(), function (props) {
  return props.theme['@size-sm'];
}, function (props) {
  return props.theme['@text-color-base'];
});
var WindowContentContainer = styledTypes_1.styled.div(_templateObject4(), function (props) {
  return props.theme['@size-s'];
});
var PopoutGlobalStyles = (0, styled_components_1.createGlobalStyle)(_templateObject5());